import { render, staticRenderFns } from "./educationCourseHistory.vue?vue&type=template&id=176900d0"
import script from "./educationCourseHistory.vue?vue&type=script&lang=js"
export * from "./educationCourseHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('176900d0')) {
      api.createRecord('176900d0', component.options)
    } else {
      api.reload('176900d0', component.options)
    }
    module.hot.accept("./educationCourseHistory.vue?vue&type=template&id=176900d0", function () {
      api.rerender('176900d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/edu/cc/educationCourseHistory.vue"
export default component.exports